<template>
  <div>
    <b-card-actions action-collapse title="Guide line Container">
      <div >
        <div class="custom-search d-flex justify-content-end">
          <div class="text-right mlr10" @click="saveGuideLine()">
            <b-button variant="gradient-primary" class="btn-icon">
              <feather-icon icon="SaveIcon" />
            </b-button>
          </div>
          <!-- <div class="btn-delete-all text-right" @click="uploadData()">
            <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="UploadIcon" />
            </b-button>
          </div> -->
           <vue-xlsx-table @on-select-file="handleSelectedFile" class="btn-icon-upload"><feather-icon icon="UploadIcon" /></vue-xlsx-table>

        </div>
        <div>
          <b-row
            class="mt-1"
            v-for="(item, i) in guideLineTab"
            :id="item.id"
            :key="i"
          >
            <b-col b-col cols="12" lg="4" md="4" sm="4">
              <b-form-group label="Depart" label-for="Depart">
                <v-select
                  id="Depart"
                  v-model="item.departurePort"
                  label="Depart"
                  placeholder="Depart"
                  :options="departPortArray"
                >
                </v-select>
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="4" md="4" sm="4">
              <b-form-group label="Arrival" label-for="Arrival">
                <v-select
                  id="Arrival"
                  v-model="item.arrivalPort"
                  label="Arrival"
                  placeholder="Arrival"
                  :options="arrivalPortArray"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="4" md="4" sm="4">
             <b-form-group label="Date" label-for="Date">
              <b-form-datepicker
                id="Date"
                v-model="item.date"
                class="mb-1"
                placeholder="Date"
              />
               </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="4" md="4" sm="4">
              <b-form-group label="Container" label-for="Container">
                <v-select
                  id="Container"
                  v-model="item.container"
                  label="Container"
                  placeholder="Container"
                  :options="containerArray"
                >
                </v-select>
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="4" md="4" sm="4">
              <b-form-group label-for="cargoTemperature" label="Peperishable cargo requiring temperature
                  control">
                <b-form-input
                  placeholder="cargo Temperature"
                  v-model="item.cargoTemperature"
                  required
                  id="cargoTemperature"
                  disable
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="4" md="4" sm="4">
              <b-form-group label-for="cargoSpecialEquipment" label="Cargo requiring special equipment">
                <b-form-input
                  placeholder="cargoSpecialEquipment"
                  v-model="item.cargoSpecialEquipment"
                  required
                  id="cargoSpecialEquipment"
                  disable
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="4" md="4" sm="4">
              <b-form-group label="Commodity" label-for="Commodity">
                <v-select
                  id="Commodity"
                  v-model="item.commodity"
                  label="Commodity"
                  placeholder="Commodity"
                  :options="commodityArray"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainItem(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeItem(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormDatepicker
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BFormDatepicker,
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      guideLineTab: [
        {
          id: 0,
          departurePort: "",
          arrivalPort: "",
          date: "",
          container: "",
          cargoTemperature: "",
          cargoSpecialEquipment: "",
          commodity: "",
        },
      ],
      departPortArray: [],
      arrivalPortArray: [],
      containerArray: [],
      commodityArray: [],
    };
  },
  mounted() {
    //this.initTrHeight()
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.getAllData();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    async getAllData(){
      this.departPortArray=[]
      this.arrivalPortArray=[]
      this.containerArray=[]
      this.commodityArray=[]

      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/agents"
      );
      response.data.data.forEach(element => {
        this.departPortArray.push(
            {
              "title":element.seaPort || element.company,
              "id":element.user._id
            },
          )
           this.arrivalPortArray.push(
            {
              "title":element.seaPort || element.company,
              "id":element.user._id
            },
          )
      });
      // container
         await axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/containers"
        )
        .then((response) => {
          console.log("containers",response.data.data);
          response.data.data.forEach((element,index) => {
            this.containerArray.push({
              "id": index,
              "title": element.title,
              "value":element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
        // commodity
         await axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/commodities"
        )
        .then((response) => {
          console.log("containers",response.data.data);
          response.data.data.forEach((element,index) => {
            this.commodityArray.push({
              id: index,
              title: element.title,
              "value":element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    saveGuideLine() {
      axios
        .put(
          "https://mtl-feeder-nodejs.onrender.com/api/guidelines",
          this.guideLineTab
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Guide line updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
    repeateAgainItem(index) {
      this.guideLineTab.push({
        id:index+1,
        departurePort: "",
          arrivalPort: "",
          date: "",
          container: "",
          cargoTemperature: "",
          cargoSpecialEquipment: "",
          commodity: "",
      });
    },
    removeItem(index) {
      this.guideLineTab.splice(index, 1);
      // this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    handleSelectedFile (convertedData) {
      console.log(convertedData)
       this.guideLineTab=convertedData.body
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
.btn-add {
  margin-top: 20px;
}
.btn-icon-upload button{
  background-image: linear-gradient(47deg, #010022, #030055)!important;
  padding: 0.715rem 0.736rem;
  text-align: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.358rem
}
</style>